import { FC, ReactNode } from 'react'
import { Collapse } from 'antd'
import { CollapseIcon } from '../icons/CollapseIcon'

interface CollapseComponentProps {
	dark?: boolean
	extra?: string
	header?: ReactNode
	children?: JSX.Element[] | string | React.ReactNode
	ghost?: boolean
}

export const CollapseComponent: FC<CollapseComponentProps> = ({
	dark, // = true,
	extra,
	header: label = 123123,
	children = <div>123123123321</div>,
	ghost = true
}) => {
	return (
		<Collapse
			expandIconPosition="end"
			size="small"
			ghost={ghost}
			expandIcon={(a) => (
				<CollapseIcon
					collapsed={!!a.isActive}
					collapsedColor={dark ? '#fff' : '#3894EB'}
					expandedColor={dark ? '#fff' : '#3894EB'}
				/>
			)}
			style={{
				backgroundColor: dark ? '#3C526A' : '#fff',
				color: dark ? '#9EB4CC' : '#fff',
				borderRadius: 10,
				border: 0,
				margin: 15
			}}
			items={[
				{
					key: '1',
					extra,
					label: (
						<h2
							style={{
								margin: 0,
								color: dark ? '#fff' : '#142D49',
								fontSize: 19,
								lineHeight: '17px',
								fontWeight: 'bold'
							}}>
							{label}
						</h2>
					),
					children
				}
			]}
		/>
	)
}
